import vueWrapper from "../../utils/vue-wrapper";
import commonStore from '../global/common-store';
import app from './app.vue';

export default () => {
  vueWrapper(app, "product-main-new", "#productJson", commonStore, true);
};
